<template>
<!--  <vs-select-->
<!--    class="w-full"-->
<!--    :label="label"-->
<!--    v-model="selected"-->
<!--    v-debounce:300ms="search"-->
<!--    autocomplete-->
<!--  >-->
<!--    <vs-select-item-->
<!--      :key="index"-->
<!--      :value="item"-->
<!--      :text="item.name"-->
<!--      v-for="(item,index) in dataList.hits"-->
<!--    />-->
<!--  </vs-select>-->

  <div class="w-full">
    <label for="" class="vs-select--label">Select Business</label>
    <ais-instant-search
      :search-client="searchClient"
      index-name="business"
    >
      <ais-autocomplete>
        <div slot-scope="{ currentRefinement, indices, refine }">
          <input
            type="search"
            :value="currentRefinement"
            placeholder="Type keyword..."
            :class="`w-full vs-input--input normal ${inputClass}`"
            @input="refine($event.currentTarget.value)"
            @focus="() => showDropdown = true"
          >

          <div v-if="data.id && data.name">
            <span class="font-semibold">{{ data.name }}</span>
            <!-- <div class="flex" style="align-items: center; border-radius: 5px;">
              <vs-avatar :src="data.logoUrl" :text="data.name" />
              <span>{{ data.name }}</span>
            </div> -->
          </div>

          <div v-if="currentRefinement && showDropdown">
            <ul v-for="index in indices" :key="index.label" class="mt-10">
              <li>
                <ul>
                  <li v-for="hit in index.hits" :key="hit.objectID">
                    <div class="flex cursor-pointer" style="align-items: center; border-radius: 5px;" @click="() => onClick(hit)">
                      <vs-avatar :src="hit.logoUrl" :text="hit.name" />
                      <ais-highlight attribute="name" :hit="hit"/>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

        </div>
      </ais-autocomplete>
    </ais-instant-search>
  </div>
</template>

<script>
import algoliasearch from 'algoliasearch/lite'
import { AisInstantSearch, AisAutocomplete, AisHighlight } from 'vue-instantsearch'

const searchClient = algoliasearch(
  'LDIZ2B1ORC',
  '8874bfba142ffce7e727698a1abd7704'
);

export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: ''
        }
      }
    },
    label: {
      type: String,
      default: 'Business'
    },
    inputClass: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      searchClient,
      isSearching: false,
      searchQuery: '',
      dataList: {
        hits: [],
        query: ''
      },
      showDropdown: false
    }
  },
  components: { AisInstantSearch, AisAutocomplete, AisHighlight },
  computed: {
    arrayData: {
      get () {
        return this.store.getters['business/arrayData']
      }
    },
    selected: {
      get () {
        return this.data.name
      },
      set (val) {
        this.$emit('change', val)
      }
    }
  },
  methods: {
    search() {
      this.isSearching = true
      this.store.dispatch('businessDoc/search', this.searchQuery)
        .then((res) => {
          this.dataList = res
          this.$forceUpdate()
        })
        .catch((e) => console.log(e))
        .then(() => this.isSearching = false)
    },
    onClick(val) {
      console.log(val)
      this.$emit('change', val)
      this.showDropdown = false
    }
  }
}
</script>

<style>
  .cursor-pointer:hover {
    background-color: #E5E8EB;
  }
</style>
